// MODO DEMO — APAGADO (este es el archivo que entra al bundle de PRODUCCIÓN).
//
// El build demo sustituye este módulo por `src/demo/modo.demo.js` mediante
// `NormalModuleReplacementPlugin` (ver `craco.config.js`, rama DEMO_BUILD). Así el bundle
// de producción NO incluye ni los fixtures, ni el adaptador, ni la sesión ficticia:
// solo estas tres líneas inertes.
export const DEMO_ACTIVO = false;
export const SESION_DEMO = null;
export function instalarDemo() {}
